import type { ValidateCrossBorderResponse } from '../../../../generated-types';

export const sepaWarnings = ['0304', '0305', '0306', '0307'];
export const pbdWarning = '0308';
export const duplicateWarning = '0021';
export const invalidAccountNumberWarning = '0310';

const validateCrossBorderWarnings = (
    validationResponse: ValidateCrossBorderResponse,
    invalidAccountNumberCallback: (invalid: boolean) => void,
    errorCallback: (blockedError: boolean) => void,
    sepaWarningCallback: (warning: boolean) => void,
) => {
    const blocked = validationResponse.warnings.some(
        (warning) =>
            !sepaWarnings.includes(warning.code) && warning.code !== pbdWarning && warning.code !== duplicateWarning,
    );
    const invalidAccountNumber = validationResponse.warnings.some(
        (warning) => warning.code === invalidAccountNumberWarning,
    );
    const sepaWarning = validationResponse.warnings.some((warning) => sepaWarnings.includes(warning.code));

    errorCallback(blocked);
    invalidAccountNumberCallback(invalidAccountNumber);
    sepaWarningCallback(sepaWarning);
};

export default validateCrossBorderWarnings;
